module.exports = __webpack_public_path__ + "img/home_banner2.57648a51.jpg";